import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { streamUrl } from '../../variables/index'
import { Avatar } from 'antd'
import Authentication from '../../modules/Authentication'
import Avatar2 from '../../assets/img/avatar_2.png'
import styled from 'styled-components'
import { Row } from 'antd'
const ShadowAvatar = styled(Avatar)`
  margin-left: 10px;
  margin-bottom: 10px;
  background: rgb(83, 69, 151);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
`
class MemberAvatarView extends Component {
  auth = new Authentication()

  render() {
    const { id, size, shape } = this.props

    return (
      <ShadowAvatar
        src={id ? `${streamUrl}files/${id}?action=view&access_token=${this.auth.getAccessToken()}` : Avatar2}
        // shape={shape}
        size={size}
        style={
          id && {
            backgroundColor: '#fff',
            marginLeft: 10,
            marginBottom: 10,
          }
        }
      />
    )
  }
}

MemberAvatarView.propTypes = { id: PropTypes.string.isRequired }
MemberAvatarView.defaultProps = { size: 'large', shape: 'circle' }

export default MemberAvatarView
